/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAllAnimalsForOfflineQueryResponse, ListAllAnimalsForOfflinePathParams, ListAllAnimalsForOfflineQueryParams, ListAllAnimalsForOffline400, ListAllAnimalsForOffline401, ListAllAnimalsForOffline403, ListAllAnimalsForOffline404, ListAllAnimalsForOffline409, ListAllAnimalsForOffline500 } from "../../types/livestockController/ListAllAnimalsForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAllAnimalsForOffline } from "../../client/livestockController/listAllAnimalsForOffline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAllAnimalsForOfflineQueryKey = (organizationId: ListAllAnimalsForOfflinePathParams["organizationId"] | undefined, params?: ListAllAnimalsForOfflineQueryParams) => [{ url: '/api/organizations/:organizationId/animals/all', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAllAnimalsForOfflineQueryKey = ReturnType<typeof listAllAnimalsForOfflineQueryKey>

export function listAllAnimalsForOfflineQueryOptions(organizationId: ListAllAnimalsForOfflinePathParams["organizationId"] | undefined, params?: ListAllAnimalsForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAllAnimalsForOfflineQueryKey(organizationId, params)
        return queryOptions<ListAllAnimalsForOfflineQueryResponse, ResponseErrorConfig<ListAllAnimalsForOffline400 | ListAllAnimalsForOffline401 | ListAllAnimalsForOffline403 | ListAllAnimalsForOffline404 | ListAllAnimalsForOffline409 | ListAllAnimalsForOffline500>, ListAllAnimalsForOfflineQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAllAnimalsForOffline(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Full non-paginated animal dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/animals/all}
 */
export function useListAllAnimalsForOffline<TData = ListAllAnimalsForOfflineQueryResponse, TQueryData = ListAllAnimalsForOfflineQueryResponse, TQueryKey extends QueryKey = ListAllAnimalsForOfflineQueryKey>(organizationId: ListAllAnimalsForOfflinePathParams["organizationId"] | undefined, params?: ListAllAnimalsForOfflineQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAllAnimalsForOfflineQueryResponse, ResponseErrorConfig<ListAllAnimalsForOffline400 | ListAllAnimalsForOffline401 | ListAllAnimalsForOffline403 | ListAllAnimalsForOffline404 | ListAllAnimalsForOffline409 | ListAllAnimalsForOffline500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAllAnimalsForOfflineQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAllAnimalsForOfflineQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAllAnimalsForOffline400 | ListAllAnimalsForOffline401 | ListAllAnimalsForOffline403 | ListAllAnimalsForOffline404 | ListAllAnimalsForOffline409 | ListAllAnimalsForOffline500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}